module.exports = "/lucky-balls/img/bonus_yellow/header_pinnbet.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header_pinnbet.png
// module id = 969
// module chunks = 0